import { render, staticRenderFns } from "./PdfWidget.vue?vue&type=template&id=d0a04236&scoped=true"
import script from "./PdfWidget.vue?vue&type=script&lang=js"
export * from "./PdfWidget.vue?vue&type=script&lang=js"
import style0 from "./PdfWidget.vue?vue&type=style&index=0&id=d0a04236&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a04236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0a04236')) {
      api.createRecord('d0a04236', component.options)
    } else {
      api.reload('d0a04236', component.options)
    }
    module.hot.accept("./PdfWidget.vue?vue&type=template&id=d0a04236&scoped=true", function () {
      api.rerender('d0a04236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/PdfWidget.vue"
export default component.exports